import ExcelJS from "exceljs";
import moment from "moment";
import i18n from "../i18n";

function esFecha(fechaString) {
  const fechaSinMilisegundos = fechaString.split(".")[0];
  const formato = "YYYY-MM-DDTHH:mm:ss";
  return moment(fechaSinMilisegundos, formato, true).isValid();
}

function formatDate(date) {
  var fecha = null;
  if (esFecha(date)) {
    fecha = moment.utc(date);
  } else {
    return date;
  }
  return moment(fecha._d).format("MM/DD/YYYY h:mm A");
}

const useExcelExport = () => {
  const exportToExcel = (data, columns, fileName) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Data");

    if (data.length > 0) {
      const keys = Object.keys(data[0]);
      const intersection = keys.filter((value) =>
        columns.map((id) => id.id).includes(value)
      );
      worksheet.columns = columns.map(({ id, label }) => ({
        header: label.toUpperCase(),
        key: id,
        width: 15,
      }));

      data.forEach((item) => {
        const rowData = {};
        intersection.forEach((key) => {
          if (typeof item[key] === "string") {
            rowData[key] = formatDate(item[key]);
          } else if (typeof item[key] === "boolean") {
            rowData[key] = item[key] === true ? i18n.t("utils.excelExport.active") : i18n.t("utils.excelExport.inactive");
          } else if (typeof item[key] === "object" && item[key] !== null) {
            const Subfiltered = Object.keys(item[key])
              .filter(
                (key1) => !key1.startsWith("id") || key1.endsWith("Navigation")
              )
              .sort((a, b) => {
                return a.localeCompare(b);
              });
            if (!Array.isArray(item[key])) {
              Subfiltered.forEach((key2, index) => {
                rowData[key] =
                  item[key][key2] !== null && item[key][key2] !== "undefined"
                    ? item[key][key2]
                    : "";
              });
            } else {
              Object.keys(item[key]).forEach((subKey, i) => {
                const SubfilteredKeys = Object.keys(item[key][subKey])
                  .filter(
                    (key1) =>
                      !key1.startsWith("id") || key1.endsWith("Navigation")
                  )
                  .sort((a, b) => {
                    return a.localeCompare(b);
                  });
                SubfilteredKeys.forEach((key2, index) => {
                  if (
                    typeof item[key][subKey][key2] === "object" &&
                    item[key][subKey][key2] !== null
                  ) {
                    Object.keys(item[key][subKey][key2]).forEach(
                      (key3, index2) => {
                        if (rowData[key]) {
                          rowData[key] +=
                            `${i + 1}. ` + item[key][subKey][key2][key3];
                        } else {
                          rowData[key] =
                            `${i + 1}. ` + item[key][subKey][key2][key3] + "\n";
                        }
                      }
                    );
                  } else {
                    const salto = Subfiltered.length > 1 ? "\n" : "";
                    if (rowData[key]) {
                      if (index === 1) {
                        rowData[key] += "-" + item[key][subKey][key2] + "\n";
                      } else {
                        rowData[key] += item[key][subKey][key2] + "\n";
                      }
                    } else {
                      rowData[key] = item[key][subKey][key2] + salto;
                    }
                  }
                });
              });
            }
          } else {
            rowData[key] = item[key];
          }
        });
        const row = worksheet.addRow(rowData);
        row.eachCell({ includeEmpty: true }, function (cell) {
          cell.alignment = { wrapText: true };
        });
      });
      worksheet.columns.forEach((column) => {
        let maxWidth = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const length = cell.value ? cell.value.toString().length : 0;
          maxWidth = Math.max(maxWidth, length);
        });
        column.width = maxWidth < 10 ? 10 : maxWidth + 2;
      });
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      });
    }
  };

  return exportToExcel;
};

export default useExcelExport;
